import { AdaptiveDesignSystem, anchorAestheticStyles, anchorStyleModules, anchorTemplateStyles, composeAnchor } from "@adaptive-web/adaptive-web-components";
import { css } from "@microsoft/fast-element";

export const customAnchorDefinition = composeAnchor(AdaptiveDesignSystem, {
  styleModules: anchorStyleModules,
  styles: [
    anchorTemplateStyles,
    anchorAestheticStyles,
    css`
      :host {
        --font-variations: 'wght' 600;
      }

      .icon-only {
        padding-top: var(--density_control-vertical-padding) !important;
        padding-right: var(--density_control-horizontal-padding) !important;
        padding-bottom: var(--density_control-vertical-padding) !important;
        padding-left: var(--density_control-horizontal-padding) !important;
      }

      [part=content] {
        font-family: var(--body-font-family);
        font-variation-settings: 'wght' 600;
      }

      .control {
        border: none !important;
        background-color: var(--primary-color) !important;
        color: var(--on-primary-color) !important;

        & ::slotted(svg) {
          color: var(--secondary-color);
        }
      }

      :host([appearance="accent"]) .control {
        background-color: var(--secondary-color) !important;
        color: var(--on-secondary-color) !important;

        & ::slotted(svg) {
          color: var(--primary-color);
        }
      }

      :host([appearance="accent"]:hover) .control {
        box-shadow: inset 0 0 0 2px var(--secondary-color), inset 0 0 0 4px currentcolor;
      }

      :host([appearance="lightweight"]:hover) .control,
      :host(:not([appearance]):hover) .control {
        box-shadow: inset 0 0 0 2px var(--primary-color), inset 0 0 0 4px var(--secondary-color);
      }

      :host([appearance="accent"]) .control:focus-visible {
        --focus-stroke-outer: #ffffff;
      }

      :host([appearance="lightweight"]) .control:focus-visible {
        --focus-stroke-outer: #22303D;
      }
    `
  ]
})